export function slickSliders() {
  var $slider = jQuery(".sliderexample-slick-slider");
  if ($slider.length === 0) {
    return;
  }

  // 1. Initialize standard Slick slider
  $slider.slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: false,
    swipe: true,
    speed: 400,
    // Smooth transition duration on click
    responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 770,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }]
  });
  var $track = $slider.find('.slick-track');
  function startLinear() {
    $track.addClass('slick-linear-active').removeClass('is-paused');
  }
  function pauseLinear() {
    $track.addClass('is-paused');
  }
  function stopLinear() {
    $track.removeClass('slick-linear-active is-paused');
  }

  // Start initial continuous linear motion
  startLinear();

  // 2. Hover handlers (Pause on enter, Resume on leave)
  $slider.on('mouseenter', pauseLinear).on('mouseleave', startLinear);
  jQuery('.sliderexample-prev, .sliderexample-next').on('mouseenter', pauseLinear).on('mouseleave', function () {
    if (!$slider.is(':hover')) {
      startLinear();
    }
  });

  // 3. Working Click Handlers
  jQuery('.sliderexample-prev').off('click').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    // Kill keyframes so Slick can execute the transform step natively
    stopLinear();
    $slider.slick('slickPrev');
  });
  jQuery('.sliderexample-next').off('click').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    // Kill keyframes so Slick can execute the transform step natively
    stopLinear();
    $slider.slick('slickNext');
  });

  // Window Resize Safety
  jQuery(window).on('resize', function () {
    stopLinear();
    $slider.slick('refresh');
    startLinear();
  });
}